// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DatapointsExcelRequestSpecificsFromJSON, DatapointsExcelRequestSpecificsToJSON, DatapointsRequestBaseFromJSON, DatapointsRequestBaseToJSON, DatapointsRequestOptionsFromJSON, DatapointsRequestOptionsToJSON, } from './';
export function DatapointsExcelRequestFromJSON(json) {
    return {
        ...DatapointsExcelRequestSpecificsFromJSON(json),
        ...DatapointsRequestBaseFromJSON(json),
        ...DatapointsRequestOptionsFromJSON(json),
    };
}
export function DatapointsExcelRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        ...DatapointsExcelRequestSpecificsToJSON(value),
        ...DatapointsRequestBaseToJSON(value),
        ...DatapointsRequestOptionsToJSON(value),
    };
}
